import { usePage } from "@inertiajs/react";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import { UserBookPageProps } from "./show.props";
import ProfileWrapper from "components/profile/ProfileWrapper";
import ProfileLibraryNav from "components/profile/ProfileLibraryNav";
import { Letterbooks } from "features/Letterbooks";

function UserBookPage() {
  const { user, letterbooks } = usePage<UserBookPageProps>().props;

  return (
    <ProfileWrapper user={user}>
      <ProfileLibraryNav username={user.username} />
      <Letterbooks context={letterbooks} />
    </ProfileWrapper>
  );
}

UserBookPage.layout = DefaultLayoutWrapper;
export default UserBookPage;